import { useEffect, useState } from "react";

export default function BackgroundVideo() {
  // No video/source is included in prerendered HTML or before preferences are checked.
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const motion = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    const data = window.matchMedia?.("(prefers-reduced-data: reduce)");
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const update = () => setEnabled(!(motion?.matches || data?.matches || connection?.saveData));
    const queries = [motion, data].filter(Boolean);
    queries.forEach(query => {
      if (query.addEventListener) query.addEventListener("change", update);
      else query.addListener?.(update);
    });
    connection?.addEventListener?.("change", update);
    update();
    return () => {
      queries.forEach(query => {
        if (query.removeEventListener) query.removeEventListener("change", update);
        else query.removeListener?.(update);
      });
      connection?.removeEventListener?.("change", update);
    };
  }, []);

  if (!enabled) return null;
  return (
    <div className="videowrapper" aria-hidden="true">
      <video autoPlay loop muted playsInline>
        <source src="/images/header.mp4" type="video/mp4" />
      </video>
    </div>
  );
}
